export var mutations = {
    setLoading: function (s, loading) {
        s.loading = loading;
    },
    setConsents: function (s, payload) {
        s.consents = payload;
    },
    setExportSystems: function (s, payload) {
        s.exportSystems = payload;
    },
    setExportJobs: function (s, payload) {
        s.exportJobs = payload;
    },
    setSelectedExportJob: function (s, payload) {
        s.selectedExportJob = payload;
    },
    setSelectedRecruitmentAssociation: function (s, payload) {
        s.selectedRecruitmentAssociation = payload;
    },
    setExportJobsPaginationNextCursor: function (s, payload) {
        s.exportJobsPagination.nextCursor = payload;
    },
    setExportJobsPaginationCursorStack: function (s, payload) {
        s.exportJobsPagination.cursorStack = payload;
    },
    resetExportJobsPagination: function (s) {
        s.exportJobsPagination.reset();
    },
};
